import { filter, prop, propEq, sortBy } from 'ramda';
import { applyFranchiseToIntervals } from '../hooks/helpers/applyFranchiseToIntervals.js';
import { createIntervalLabel, EMPTY_RO_INTERVALS, RO_DISCLAIMER_NOTE } from '../hooks/helpers/intervalsHelpers.js';

const getCaisseDelai = (sortedNodes) => {
  // Si le premier node commence à 4, le délai est de 3 jours (0-3)
  // Si le premier node commence à 16, le délai est de 15 jours (0-15)
  const firstNodePlafondMin = sortedNodes[0]?.plafondMin || 4;
  return firstNodePlafondMin - 1;
};

const createCaisseDelaiInterval = (caisseDelai) => ({
  plafondMin: 0,
  plafondMax: caisseDelai,
  value: '0',
  label: createIntervalLabel(0, caisseDelai)
});

const buildGraphRows = (intervals) => {
  return intervals.map(interval => ({
    label: interval.label,
    columns: [
      {
        label: 'Assureur',
        value: 0
      },
      {
        label: 'Régime obligatoire',
        value: parseFloat(interval.value) || 0
      }
    ]
  }));
};

const buildROIntervalsWithFranchise = (guarantees, franchiseConfig = {}, franchise = null) => {
  const {
    hasMaladie = false,
    hasAccident = false,
    hasHospitalisation = false,
    hasToutesCauses = false
  } = franchiseConfig;

  const incapaciteMontantNodes = filter(
    propEq('key', 'INCAPACITE_MONTANT'),
    guarantees?.OPTION_INCAP_CAP?.nodes || []
  );

  if (incapaciteMontantNodes.length === 0) {
    return EMPTY_RO_INTERVALS;
  }

  const sortedNodes = sortBy(prop('plafondMin'), incapaciteMontantNodes);
  const caisseDelai = getCaisseDelai(sortedNodes);

  let intervals = [createCaisseDelaiInterval(caisseDelai)];

  sortedNodes.forEach(node => {
    intervals.push({
      plafondMin: node.plafondMin,
      plafondMax: node.plafondMax,
      value: node.value,
      label: createIntervalLabel(node.plafondMin, node.plafondMax)
    });
  });

  if (franchise && franchise > 0) {
    intervals = applyFranchiseToIntervals(intervals, franchise);
  }

  const labels = intervals.map(interval => interval.label);
  const ROs = intervals.map(interval => interval.value);
  const hasSeparateFranchises = (hasMaladie || hasAccident || hasHospitalisation) && !hasToutesCauses;

  return {
    labels,
    ROs,
    rows: buildGraphRows(intervals),
    note: RO_DISCLAIMER_NOTE,
    hasSeparateFranchises,
    intervals
  };
};

export default buildROIntervalsWithFranchise;
